var BxfDynamicPositionEnum;
(function (BxfDynamicPositionEnum) {
    BxfDynamicPositionEnum["BOTTOM_CENTER"] = "bottomCenter";
    BxfDynamicPositionEnum["BOTTOM_LEFT"] = "bottomLeft";
    BxfDynamicPositionEnum["BOTTOM_RIGHT"] = "bottomRight";
    BxfDynamicPositionEnum["TOP_CENTER"] = "topCenter";
    BxfDynamicPositionEnum["TOP_LEFT"] = "topLeft";
    BxfDynamicPositionEnum["TOP_RIGHT"] = "topRight";
    BxfDynamicPositionEnum["LEFT_CENTER"] = "leftCenter";
    BxfDynamicPositionEnum["LEFT_TOP"] = "leftTop";
    BxfDynamicPositionEnum["LEFT_BOTTOM"] = "leftBottom";
    BxfDynamicPositionEnum["RIGHT_CENTER"] = "rightCenter";
    BxfDynamicPositionEnum["RIGHT_TOP"] = "rightTop";
    BxfDynamicPositionEnum["RIGHT_BOTTOM"] = "rightBottom";
    BxfDynamicPositionEnum["CENTER"] = "Center";
    BxfDynamicPositionEnum["RIGHT"] = "Right";
})(BxfDynamicPositionEnum || (BxfDynamicPositionEnum = {}));
const DefaultFlipOrder = [
    BxfDynamicPositionEnum.BOTTOM_CENTER,
    BxfDynamicPositionEnum.BOTTOM_LEFT,
    BxfDynamicPositionEnum.BOTTOM_RIGHT,
    BxfDynamicPositionEnum.TOP_CENTER,
    BxfDynamicPositionEnum.TOP_LEFT,
    BxfDynamicPositionEnum.TOP_RIGHT,
    BxfDynamicPositionEnum.LEFT_CENTER,
    BxfDynamicPositionEnum.LEFT_TOP,
    BxfDynamicPositionEnum.LEFT_BOTTOM,
    BxfDynamicPositionEnum.RIGHT_CENTER,
    BxfDynamicPositionEnum.RIGHT_TOP,
    BxfDynamicPositionEnum.RIGHT_BOTTOM,
];
const DefaultTooltipFlipOrder = [
    BxfDynamicPositionEnum.BOTTOM_LEFT,
    BxfDynamicPositionEnum.BOTTOM_RIGHT,
    BxfDynamicPositionEnum.TOP_LEFT,
    BxfDynamicPositionEnum.TOP_RIGHT,
    BxfDynamicPositionEnum.LEFT_TOP,
    BxfDynamicPositionEnum.LEFT_BOTTOM,
    BxfDynamicPositionEnum.RIGHT_TOP,
    BxfDynamicPositionEnum.RIGHT_BOTTOM,
];

const BxfChatCanvasConstants = {
    CANVAS: 'bxf-chat-canvas',
    CANVAS_CONTAINER: 'bxf-chat-canvas__container',
    SCROLL_CONTAINER_ID: 'bxf-chat-canvas-scroll-container',
    CANVAS_CONTAINER_STANDALONE: 'bxf-chat-canvas__container--standalone',
    CANVAS_LOGIN_SPARKLE: 'bxf-chat-canvas__login-sparkle',
    CANVAS_LOGIN_SPARKLE_SMALL: 'bxf-chat-canvas__login-sparkle--small',
    CANVAS_LOGIN_LINE_ITEM1: 'bxf-chat-canvas__login-line-item1',
    CANVAS_LOGIN_LINE_ITEM2: 'bxf-chat-canvas__login-line-item2',
    CANVAS_LOGIN_LINE_ITEM3: 'bxf-chat-canvas__login-line-item3',
    CANVAS_LOGIN_LINE_ITEM4: 'bxf-chat-canvas__login-line-item4',
    CANVAS_LOGIN_LINE_ITEM1_SMALL: 'bxf-chat-canvas__login-line-item1--small',
    CANVAS_LOGIN_LINE_ITEM2_SMALL: 'bxf-chat-canvas__login-line-item2--small',
    CANVAS_LOGIN_LINE_ITEM3_SMALL: 'bxf-chat-canvas__login-line-item3--small',
    CANVAS_LOGIN_LINE_ITEM4_SMALL: 'bxf-chat-canvas__login-line-item4--small',
    CANVAS_LOGIN_BUTTON: 'bxf-chat-canvas__login-button',
    CANVAS_LOGIN_BUTTON_SMALL: 'bxf-chat-canvas__login-button--small',
    CANVAS_LOGIN_LOGO: 'bxf-chat-canvas__login-logo',
    CANVAS_LOGIN_LOGO_SMALL: 'bxf-chat-canvas__login-logo--small',
    CANVAS_LOGIN_TRADEMARK: 'bxf-chat-canvas__login-trademark',
    CANVAS_LOGIN_BETA_LOGO: 'bxf-chat-canvas__login-beta-logo',
    CANVAS_LOGIN_BETA_LOGO_SMALL: 'bxf-chat-canvas__login-beta-logo--small',
    CANVAS_LOGIN_RECTANGLE1: 'bxf-chat-canvas__login-rectangle1',
    CANVAS_LOGIN_RECTANGLE2: 'bxf-chat-canvas__login-rectangle2',
    CANVAS_LOGIN_RECTANGLE3: 'bxf-chat-canvas__login-rectangle3',
    CANVAS_LOGIN_RECTANGLE4: 'bxf-chat-canvas__login-rectangle4',
    CANVAS_LOGIN_RECTANGLE1_SMALL: 'bxf-chat-canvas__login-rectangle1--small',
    CANVAS_LOGIN_RECTANGLE2_SMALL: 'bxf-chat-canvas__login-rectangle2--small',
    CANVAS_LOGIN_RECTANGLE3_SMALL: 'bxf-chat-canvas__login-rectangle3--small',
    CANVAS_LOGIN_RECTANGLE4_SMALL: 'bxf-chat-canvas__login-rectangle4--small',
    CANVAS_CONTAINER_EMBEDDED: 'bxf-chat-canvas__container--embedded',
    CANVAS_CONTAINER_EMBEDDED_FULLSCREEN: 'bxf-chat-canvas__container--embedded-fullscreen',
    CANVAS_HEADER: 'bxf-chat-canvas__header',
    CANVAS_HEADER_CONTAINER: 'bxf-chat-canvas__header-container',
    CANVAS_HEADER_CONTAINER_STANDALONE: 'bxf-chat-canvas__header-container--standalone',
    CANVAS_HEADER_CONTAINER_FULLSCREEN: 'bxf-chat-canvas__header-container--fullscreen',
    CANVAS_HEADER_CONTAINER_INNER: 'bxf-chat-canvas__header-container--inner',
    CANVAS_WELCOME_CONTAINER: 'bxf-chat-canvas__welcome-container',
    CANVAS_HEADER_ACTION_BUTTON_CONTAINER: 'bxf-chat-canvas__header__action-button-container',
    CANVAS_MAIN_CONTENT_CONTAINER_STANDALONE: 'bxf-chat-canvas__main-content-container--standalone',
    CANVAS_MAIN_CONTENT_CONTAINER_EMBEDDED: 'bxf-chat-canvas__main-content-container--embedded',
    CANVAS_FOOTER_CONTAINER: 'bxf-chat-canvas__footer-container',
    CANVAS_FOOTER_CONTAINER_STANDALONE: 'bxf-chat-canvas__footer-container--standalone',
    CANVAS_COPILOT_BRANDING_CONTAINER: 'bxf-chat-canvas__copilot-branding-container',
    CANVAS_COPILOT_ICON_CONTAINER: 'bxf-chat-canvas__copilot-icon-container',
    CANVAS_COPILOT_TITLE: 'bxf-chat-canvas__copilot-title',
    CANVAS_COPILOT_LOGO: 'bxf-chat-canvas__copilot-logo',
    CANVAS_CONTAINER_EMBEDDED_OUTER: 'bxf-chat-canvas__container--embedded-outer',
    CANVAS_CHAT_CONTAINER: 'bxf-chat-canvas__chat-container',
    CANVAS_CHAT_CONTAINER_MAXIMIZING: 'bxf-chat-canvas__chat-container--maximizing',
    CANVAS_CHAT_CONTAINER_INNER: 'bxf-chat-canvas__chat-container--inner',
    CANVAS_CHAT_CONTAINER_EMBEDDED: 'bxf-chat-canvas__chat-container--embedded',
    CANVAS_CHAT_CONTAINER_EMBEDDED_SCROLL: 'bxf-chat-canvas__chat-container--embedded-scroll',
    CANVAS_CHAT_CONTAINER_FOOTER_BORDER: 'bxf-chat-canvas__chat-container--border-footer',
    CANVAS_CHAT_CONTAINER_HEADER_BORDER: 'bxf-chat-canvas__chat-container--border-header',
    CANVAS_IMPORTANT_INFORMATION_CONTAINER: 'bxf-chat-canvas__important-info',
    CANVAS_IMPORTANT_INFORMATION_OVERLAY_CONTAINER: 'bxf-chat-canvas__important-info--overlay-container',
    CANVAS_IMPORTANT_INFORMATION_LABEL: 'bxf-chat-canvas__important-info--label',
    CANVAS_PANEL_TAGLINE: 'bxf-chat-canvas__panel-tagline',
    CANVAS_PANEL_LOGO_TAGLINE_CONTAINER: 'bxf-chat-canvas__panel-logo-tagline-container',
    CANVAS_IMPORTANT_INFORMATION_OVERLAY: 'bxf-chat-canvas__important-info--overlay',
    CANVAS_IMPORTANT_INFORMATION_OVERLAY_LABEL: 'bxf-chat-canvas__important-info--overlay-label',
    CANVAS_IMPORTANT_INFORMATION_BODY: 'bxf-chat-canvas__important-info--body',
    CANVAS_CONTAINER_CONTENT: 'bxf-chat-canvas__chat-container--content',
    CANVAS_CHAT_CONTAINER_SCROLL: 'bxf-chat-canvas__chat-container--scroll',
    CANVAS_CHAT_CONTAINER_HIDDEN: 'bxf-chat-canvas__chat-container--hidden',
    CANVAS_ERROR_CONTAINER_EMBEDDED: 'bxf-chat-canvas__error-container--embedded',
    CANVAS_ERROR_CONTAINER_STANDALONE: 'bxf-chat-canvas__error-container--standalone',
    CANVAS_CONTAINER_ERROR_WARNING: 'bxf-chat-canvas__error-container--warning',
    CANVAS_CONTAINER_ERROR_CONTENT: 'bxf-chat-canvas__error-container--content',
    CANVAS_ERROR_CONTAINER: 'bxf-chat-canvas__error-container',
    CANVAS_ERROR_CONTAINER_HEADING: 'bxf-chat-canvas__error-container-heading',
    CANVAS_CONTAINER_CLOSE_BUTTON: 'bxf-chat-canvas__container--close-button',
    CANVAS_GENERIC_INFO_CONTAINER: 'bxf-chat-canvas__generic-info-container',
    CANVAS_GENERIC_INFO_ITEM: 'bxf-chat-canvas__generic-info-item',
    CANVAS_CONTAINER_DISMISS_BUTTON: 'bxf-chat-canvas__container-dismiss-button',
    CANVAS_ERROR_CONTAINER_SUBHEADING: 'bxf-chat-canvas__error-container-subheading',
    CANVAS_ERROR_CONTAINER_MESSAGE: 'bxf-chat-canvas__error-container-message',
    CANVAS_CHAT_DISMISS_ICON: 'bxf-chat-canvas__dismiss-icon',
    CANVAS_RECENT_PROMPTS: 'bxf-chat-canvas__recent-prompts',
    CANVAS_RECENT_PROMPTS_HEADER: 'bxf-chat-canvas__recent-prompts--header',
    CANVAS_RECENT_PROMPTS_HEADER_FULLSCREEN: 'bxf-chat-canvas__recent-prompts--header-fullscreen',
    CANVAS_RECENT_PROMPTS_CONTAINER: 'bxf-chat-canvas__recent-prompts--container',
    CANVAS_RECENT_PROMPTS_CONTAINER_FULLSCREEN: 'bxf-chat-canvas__recent-prompts--container-fullscreen',
    CANVAS_RECENT_PROMPTS_CONTAINER_MAXIMIZING: 'bxf-chat-canvas__recent-prompts--container-maximizing',
    CANVAS_RECENT_PROMPTS_TIMESTAMP: 'bxf-chat-canvas__recent-prompts--timestamp',
    CANVAS_RECENT_PROMPTS_QUERY: 'bxf-chat-canvas__recent-prompts--query',
    CANVAS_RECENT_PROMPTS_BUTTON: 'bxf-chat-canvas__recent-prompts-button',
    CANVAS_RECENT_PROMPTS_CLOSE: 'bxf-chat-canvas__recent-prompts--close-icon',
    CANVAS_CONTENT_GRID: 'bxf-canvas-content-grid',
    CANVAS_CONTENT_GRID_MINIMIZED: 'bxf-canvas-content-grid--minimized',
    CANVAS_CONTENT_GRID_FULLSCREEN: 'bxf-canvas-content-grid--fullscreen',
    CANVAS_NO_HEADER: 'bxf-chat-canvas__no-header',
    CANVAS_RESIZER: 'bxf-chat-canvas__resizer',
    CANVAS_RESIZER_BAR: 'bxf-chat-canvas__resizer-bar',
    CANVAS_RESIZER_BAR_SHADOW: 'bxf-chat-canvas__resizer-bar--shadow',
    CANVAS_RESIZER_BAR_SPACER: 'bxf-chat-canvas__resizer-bar--spacer',
    CANVAS_CONTENT: 'bxf-chat-canvas__content',
    CANVAS_CONTENT_SMALL: 'bxf-chat-canvas__content--small',
    CANVAS_CONTAINER_EMBEDDED_OUTER_OVERLAY: 'bxf-chat-canvas__container--embedded-outer--overlay',
    CANVAS_CONTAINER_EMBEDDED_OUTER_OVERLAY_CONTAINER: 'bxf-chat-canvas__container--embedded-outer--overlay-container',
    CANVAS_CONTAINER_EMBEDDED_OUTER_PUSH: 'bxf-chat-canvas__container--embedded-outer--push',
    CANVAS_LOADING_HEADER: 'ChatBLK is loading...',
    CANVAS_LOADING_SUBHEADER: 'Thanks for your patience.',
    CANVAS_LOADING_ERROR_HEADER: 'ChatBLK has failed to load.',
    CANVAS_LOADING_ERROR_SUBHEADER: 'Please hit the button below to try again.',
    CANVAS_GENERIC_EMAIL: 'askblackrock@blackrock.com',
    CANVAS_GENERIC_PHONE: '877-275-1255 (1-877-ASK-1BLK)',
    CANVAS_GENERIC_HOURS: '8:30 a.m. - 6 p.m. ET',
    CANVAS_SLOT_WELCOME: 'welcome',
    CANVAS_SLOT_CHAT: 'chat',
    CANVAS_SLOT_FOOTER: 'footer',
    CANVAS_SLOT_TARGET: 'target',
    CANVAS_SLOT_CONTENT: 'content',
    CANVAS_SLOT_IMPORTANT_INFORMATION: 'important-information',
    CANVAS_APP_NAME: 'Copilot',
    CANVAS_ADDITIONAL_ACTIONS_ASSISTIVE_TEXT: 'Additional Actions',
    CANVAS_CLOSE_BUTTON_LABEL: 'Close',
    CANVAS_DISMISS_ASSISTIVE_TEXT: 'Dismiss',
    CANVAS_NEW_CHAT_ASSISTIVE_TEXT: 'Reset',
    CANVAS_FULL_SCREEN_ASSISTIVE_TEXT: 'Fullscreen',
    CANVAS_EXIT_FULL_SCREEN_ASSISTIVE_TEXT: 'Exit Fullscreen',
    CANVAS_RECENT_ASSISTIVE_TEXT: 'Recent prompts',
    CANVAS_RECENT_ARIA_LABEL: 'Dismiss recent prompts',
    CANVAS_CONTACT_RM_ASSISTIVE_TEXT: 'Your contact',
    CANVAS_ACTION_MENU_COPY: 'Copy Chat',
    CANVAS_ACTION_MENU_EXPORT: 'Export Chat...',
    CANVAS_ACTION_MENU_HISTORY: 'Chat History',
    CANVAS_ACTION_MENU_SETTINGS: 'Copilot Settings',
    CANVAS_INTRODUCING_LABEL: 'Introducing',
    LINE_ITEM2: 'Explore products',
    LINE_ITEM3: 'Access strategies',
    LINE_ITEM4: 'Synthesize insights',
    CHAT_BLK: 'ChatBLK',
    BETA: 'BETA',
    TM: 'TM',
    CANVAS_LOGIN_BUTTON_LABEL: 'Get started',
    IMPORTANT_INFORMATION_LABEL: 'Important Info',
    ERROR_HEADER: 'ChatBLK™ has encountered an error.',
    UNVERIFIED_USER_HEADER: 'Verified Financial Professionals Only',
    UNVERIFIED_USER_SUBHEADER: 'To verify your status as a financial professional, please contact us.',
    ERROR_SUBHEADER: "We're working on fixing it",
    ERROR_BUTTON_LABEL: 'Please try again',
    RECENT_PROMPTS: 'Recent Prompts',
    RECENT_PROMPTS_DEFAULT_INSTRUCTIONS: 'Select a recent prompt the get the latest update for that question',
    CANVAS_RESIZER_VALUETEXT_PIXELS: 'pixels',
    CHAT_BLK_PANEL_LABEL: 'ChatBLK Embedded Panel',
    CHAT_BLK_PANEL_TAGLINE: 'Your AI-powered assistant',
    CANVAS_RESIZER_ORIENTATION: 'horizontal',
    CANVAS_RESIZER_LABEL: 'Resize ChatBlk Window',
    FLEX_DIRECTION_DEFAULT: 'column-reverse',
    CANVAS_RECENT_PROMPTS_BREAKPOINT: 1023,
    CANVAS_CONTAINER_EMBEDDED_ADDITIONAL_PADDING: 19,
};

export { BxfChatCanvasConstants as B, DefaultFlipOrder as D, BxfDynamicPositionEnum as a, DefaultTooltipFlipOrder as b };
